import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles35 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial35/tutorial35.zip?ref_type=heads&inline=false', download: 'tutorial35.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirtyFive= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Change the Font of Selected Text Across Multiple Lines</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/1q8Z1tEtfeM/maxresdefault.jpg"
                            alt="Tutorial 35"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this PyQt6 tutorial, you’ll learn how to change the font of selected text across multiple lines within a text editor. This step-by-step guide demonstrates how to implement dynamic font changes, allowing users to customize text styling in a multi-line environment using PyQt6 and Qt Designer.
                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Selecting and modifying text across multiple lines</li>
                            <li>Dynamically changing the font in your PyQt6 application</li>

                            <li>Integrating Qt Designer for easy UI design and text manipulation</li>

                            <li>Enhancing user experience with intuitive text formatting features</li>
                        </ul>

                        This tutorial is perfect for developers of all levels who want to enhance their applications with advanced text editing and styling capabilities.
                        <br /><br />
                        #PyQt6 #QtDesigner #Python3 #FontCustomization #TextEditing #GUI #UserInterface #TextFormatting #PythonDevelopment

                    </p>

                    <button className="seemore">
                        <DownloadFiles35 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirtyFive;
